import React from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  IconButton,
  CircularProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import EnhancedDataTable from '../../components/EnhancedDataTable';

const EntityGroupTable = ({
  entityGroups,
  columns,
  loading,
  selectedRows,
  onSelectionChange,
  onAddNew,
  onDeleteSelected,
  onRefresh,
  deleting = false
}) => {
  return (
    <Box className="main-content">
      <Box className="toolbar-container">
        <Box className="selection-info" sx={{ pl: 0 }}>
          <Typography variant="h6" className="page-title" sx={{ pl: 0, fontWeight: 'bold' }}>Manage Entity Groups</Typography>
          {selectedRows && selectedRows.length > 0 && (
            <Typography variant="body2" className="selection-info" sx={{ ml: 2 }}>
              {selectedRows.length} row{selectedRows.length !== 1 ? 's' : ''} selected
            </Typography>
          )}
        </Box>
        <Box className="button-group">
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddIcon />}
            onClick={onAddNew}
            className="action-button"
          >
            Add Group
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : <RemoveIcon />}
            onClick={onDeleteSelected}
            disabled={!selectedRows || selectedRows.length === 0 || deleting}
            className="action-button"
            sx={{
              '&.Mui-disabled': {
                opacity: 0.4,
              }
            }}
          >
            {deleting ? 'Deleting...' : 'Remove'}
          </Button>
        </Box>
      </Box>
      <Paper className="table-container">
        <EnhancedDataTable
          rows={entityGroups}
          columns={columns}
          loading={loading}
          pageSize={15}
          tableId="entity-groups-table"
          defaultSortField="name"
          defaultSortOrder="asc"
          defaultVisibleColumns={['name', 'description', 'type', 'groupType', 'parent', 'entityCount', 'pointInTime', 'actions']}
          searchPlaceholder="Search Entity groups..."
          toolbarTitle="Entity Groups"
          onRefresh={onRefresh}
          checkboxSelection={true}
          selectionModel={selectedRows}
          onSelectionModelChange={onSelectionChange}
          height="100%"
          className="custom-datagrid"
        />
      </Paper>
    </Box>
  );
};

export default EntityGroupTable;
